import { render, staticRenderFns } from "./herder.vue?vue&type=template&id=6d7a3f60&scoped=true&"
import script from "./herder.vue?vue&type=script&lang=js&"
export * from "./herder.vue?vue&type=script&lang=js&"
import style0 from "./herder.vue?vue&type=style&index=0&id=6d7a3f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7a3f60",
  null
  
)

export default component.exports